import React from "react";
import i18n from "@/utils/i18n";
import Input from "@/components/ui/input";
import Dropdown from "@/components/ui/dropdown";
import DatePicker from "@/components/ui/datepicker";
import styles from "./ReportFilterBar.module.scss";

export interface ReportFilterState {
  dateFrom?: string;
  dateTo?: string;
  departmentID?: string;
  search?: string;
}

interface ReportFilterBarProps {
  value: ReportFilterState;
  onChange: (next: ReportFilterState) => void;
  departments?: { id: string; name: string }[];
  showSearch?: boolean;
  showDateRange?: boolean;
  showDepartment?: boolean;
  extras?: React.ReactNode;
}

const ReportFilterBar: React.FC<ReportFilterBarProps> = ({
  value,
  onChange,
  departments = [],
  showSearch = true,
  showDateRange = true,
  showDepartment = true,
  extras,
}) => {
  const deptOptions = [
    { label: i18n.t("reportFilterBar.allDepartments"), value: "" },
    ...departments.map((d) => ({ label: d.name, value: d.id })),
  ];

  return (
    <div className={styles.bar}>
      {showDateRange && (
        <>
          <div className={styles.field}>
            <DatePicker
              label={i18n.t("reportFilterBar.startLabel")}
              value={value.dateFrom ? new Date(value.dateFrom) : null}
              onChange={(v) =>
                onChange({
                  ...value,
                  dateFrom:
                    v instanceof Date ? v.toISOString().slice(0, 10) : undefined,
                })
              }
            />
          </div>
          <div className={styles.field}>
            <DatePicker
              label={i18n.t("reportFilterBar.endLabel")}
              value={value.dateTo ? new Date(value.dateTo) : null}
              onChange={(v) =>
                onChange({
                  ...value,
                  dateTo:
                    v instanceof Date ? v.toISOString().slice(0, 10) : undefined,
                })
              }
            />
          </div>
        </>
      )}
      {showDepartment && (
        <div className={styles.field}>
          <Dropdown
            label="Birim"
            placeholder={i18n.t("reportFilterBar.all")}
            options={deptOptions}
            value={value.departmentID ?? ""}
            selectedLabel={
              deptOptions.find((o) => o.value === (value.departmentID ?? ""))
                ?.label ?? ""
            }
            onSelect={(v) =>
              onChange({
                ...value,
                departmentID: (Array.isArray(v) ? v[0] : v) || undefined,
              })
            }
            searchable
            allowClear
          />
        </div>
      )}
      {showSearch && (
        <div className={`${styles.field} ${styles.fieldSearch}`}>
          <Input
            label="Ara"
            placeholder="Ara..."
            value={value.search ?? ""}
            onChange={(e) => onChange({ ...value, search: e.target.value })}
          />
        </div>
      )}
      {extras && <div className={styles.extras}>{extras}</div>}
    </div>
  );
};

export default ReportFilterBar;
